<script lang="ts">
	import toCloudinaryUrl from '$lib/utils/toCloudinarUrl';

	export let name: string;
	export let url = '';
	export let size = 36;

	const colorValue = name
		.split('')
		.map((c) => c.charCodeAt(0))
		.reduce((sum, x) => sum + x, 0);
	const color = `hsl(${(colorValue % 360) - 200}, 50%, 50%)`;
</script>

<div
	class="content px-avatar"
	style="block-size:{size}px; inline-size:{size}px; background:{url ? '' : color}"
>
	{#if url}
		<img src={toCloudinaryUrl(url, size, size)} alt="avatar" width={size} height={size} />
	{:else}
		{name[0].toUpperCase()}
	{/if}
</div>

<style>
	.content {
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 100%;
		color: white;
		font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-size: 14.4px;
		font-weight: 400;
	}

	img {
		border-radius: 100%;
	}
</style>
